import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FacadeService } from 'src/app/core/services/facade.service';

@Component({
	selector: 'app-dashboard-solution-info',
	templateUrl: './dashboard-solution-info.component.html',
	styleUrls: ['./dashboard-solution-info.component.scss']
})
export class DashboardSolutionInfoComponent implements OnInit {
	/* Semaine dont on va chercher les infos */
	@Input() weekNumber: number;

	/* Si besoin de redirection */
	@Output() buildSolutionPlanningEmitter: EventEmitter<number> =
		new EventEmitter();
	@Output() validerPlanningEmitter: EventEmitter<number> = new EventEmitter();

	planningNeedValidation: boolean;
	planningNeedSolution: boolean;

	constructor(private facade: FacadeService) {}

	ngOnInit(): void {
		this.facade.solutionService
			.getSolutionInformationForDashboard(
				new Date().getFullYear(),
				this.weekNumber
			)
			.subscribe(
				(data: { optimRequired: boolean; validationRequired: boolean }) => {
					this.planningNeedSolution = data.optimRequired;
					this.planningNeedValidation = data.validationRequired;
				}
			);
	}

	buildSolutionPlanning() {
		this.buildSolutionPlanningEmitter.emit(this.weekNumber);
	}

	validerPlanning() {
		this.validerPlanningEmitter.emit(this.weekNumber);
	}
}
